import { t } from "../../../hooks/useAppTranslation";
import {useEffect, useState} from 'react';

import {addDocument} from '../../../Properties/Properties';
import {getServicePromise} from '../../HttpService/HttpService';
import {ExistingInControlFile} from '..';


export const UploadDocument = ({
                                 controlUuid,
                                 fileData,
                                 uploadingDocumentKey,
                                 onFinishUpload,
                                  saveAsDraft
                               }) => {
  // This component is for creating document for the control
  const [savingOn, setSavingOn] = useState(false);
  const [showError, setShowError] = useState(false);
  const [documentUploaded, setDocumentUploaded] = useState(false);
  const [documentCancelled, setDocumentCancelled] = useState(false);
  const [
    existingDuplicatedFile, setExistingDuplicatedFile
  ] = useState(null);

  useEffect(() => {
    if (uploadingDocumentKey === fileData.key) {
      setSavingOn(true);
    }
  }, [uploadingDocumentKey]);

  function handleCancel() {
    setExistingDuplicatedFile(null);
    setDocumentCancelled(true);
    setSavingOn(false);
    onFinishUpload();
  }

  function handleError() {
    setShowError(true);
    setSavingOn(false);
    onFinishUpload();
  }

  function handleSuccess(data) {
    if (data?.duplicatedDocument?.file?.id) {
      // it there is a value like that from backend, show popup with choices
      // then, user has to decide what to do further
      setExistingDuplicatedFile(data.duplicatedDocument.file);
      return
    }

    onFinishUpload(data?.changedDocument || null);
    setSavingOn(false);
    setDocumentUploaded(true);
  }

  useEffect(() => {
    if (!savingOn) { return }
    const callPromise = getServicePromise(
      addDocument(controlUuid,saveAsDraft),
      'POST',
      {fileId: fileData.fileId, forced: false}
    );
    callPromise.then(handleSuccess, handleError);
  }, [savingOn]);

  return (
    <>
      <li>
        {fileData.filename} {savingOn ? <p className="info-text">{ t('g-saving-document') }</p> : ''}
        {showError && <p className="error-text">{ t('g-failed-save-document') }</p>}
        {documentUploaded && <p className="info-text">{ t('g-document-saved') }</p>}
        {documentCancelled && <p className="info-text">{ t('g-document-upload-cancelled') }</p>}
      </li>
      {existingDuplicatedFile &&
        <ExistingInControlFile
          controlUuid={controlUuid}
          duplicatedFile={existingDuplicatedFile}
          fileId={fileData.fileId}
          saveAsDraft={saveAsDraft}
          onCancel={handleCancel}
          onError={() => {
            setExistingDuplicatedFile(null);
            handleError();
          }}
          onSuccess={data => {
            setExistingDuplicatedFile(null);
            handleSuccess(data);
          }}
        />
      }
    </>
  )
};
